import api from "../services/api";
import { createContext, useState } from "react";

export const RedactionContext = createContext({});

export const RedactionProvider = ({ children }) => {
  const createRedactionApi = async (data) => {
    const token = localStorage.getItem("token");
    const response = await api.post("create/user", data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json;charset=utf-8",
      },
    });
    return response;
  };

  const updateRedactionApi = async (id, data) => {
    const token = localStorage.getItem("token");
    const response = await api.post(`update/user/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json;charset=utf-8",
      },
    });
    return response;
  };

  // No seu UserContext ou onde a função listUsersApi está definida:
  const getRedactionInfoApi = async () => {
    const token = localStorage.getItem("token");
    const response = await api.get(`redactions`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };
  const getRedactionTemasApi = async () => {
    const token = localStorage.getItem("token");
    const response = await api.get(`redaction/temas`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  const getRedactionUserTemasApi = async () => {
    const token = localStorage.getItem("token");
    const response = await api.get(`/redaction/user/temas`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };
  const getRedactionCompletedUserTemasApi = async (id) => {
    const token = localStorage.getItem("token");
    const response = await api.get(`/user/${id}/completed-redactions`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  const toggleRedactionApi = async (data) => {
    const token = localStorage.getItem("token");
    const response = await api.post(`redaction/toggle`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json;charset=utf-8",
      },
    });
    return response;
  };

  return (
    <RedactionContext.Provider
      value={{
        createRedactionApi,
        updateRedactionApi,
        getRedactionInfoApi,
        getRedactionTemasApi,
        toggleRedactionApi,
        getRedactionUserTemasApi,
        getRedactionCompletedUserTemasApi,
      }}
    >
      {children}
    </RedactionContext.Provider>
  );
};
